// extracted by mini-css-extract-plugin
export default {"faqHeading":"Faq_faqHeading__Sb8Re","faqItem":"Faq_faqItem__h8-g4","faqContainer":"Faq_faqContainer__MUGuV"};